import { EnumPropertyViewModel } from '@nts/std';
import { BehaviorSubject } from 'rxjs';
import { ExpenseState } from 'src/app/expense-annotation/generated/domain-models/enums/generated-expense-state';
import { ExpenseStateMapper } from 'src/app/shared/services/expense-state-mapper';
import { GeneratedExpenseSelectionViewModel } from '../generated/view-models/generated-expense-selection.view-model';
import { ReceiptParamsViewModel } from './receipt-params.view-model';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ExpenseFileCollectionItemViewModel } from './expense-file.collection-item-view-model';
import { ExpenseFileUtils } from '../utils/expense-file.utils';

export class ExpenseSelectionViewModel extends GeneratedExpenseSelectionViewModel {

  hasActionsButtons = new BehaviorSubject<boolean>(true);
  isPreviousDisabled = new BehaviorSubject<boolean>(false);
  isValid = new BehaviorSubject<boolean>(false);
  hideNext = new BehaviorSubject<boolean>(false);
  expenseModelId: number = null;
  expenseState: EnumPropertyViewModel;
  expenseStateEnum = ExpenseState;
  expenseStateMapper = ExpenseStateMapper;
  showCurrentState: boolean;
  allFilesUploaded: boolean = true;

  newLabels(): BehaviorSubject<any[]> {
    return (this.parent as ReceiptParamsViewModel).newLabels$;
  }

  async validateStep(): Promise<void> {
    this.checkFileValidation();
    this.isValid.next(this.expenseClassification.value != null && this.allFilesUploaded);
    return Promise.resolve();
  }

  initPresentationLogic(
    expenseAnnotationId: number,
    remoteExpense: boolean,
    expenseClassificationList: number[],
    expenseModelId = null,
    expenseState: EnumPropertyViewModel,
    isEnabled: boolean
  ) {
    this.showCurrentState = expenseAnnotationId > 0 && remoteExpense === true;
    this.expenseState = expenseState;

    if (expenseModelId) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      this.expenseModelId = expenseModelId;
    }
    if (expenseClassificationList.length === 0) {
      this.expenseClassification.setValue(null);
    } else {
      if (expenseClassificationList.length === 1) {
        this.expenseClassification.setValue(expenseClassificationList[0]);
      } else if (this.expenseClassification.value > 0) {
        const found = expenseClassificationList.find((e) => e === this.expenseClassification.value);
        if (found == null) {
          this.expenseClassification.setValue(null);
        }
      }
    }
    if (!isEnabled) {
      this.expenseClassification.isEnabled = isEnabled;
    }
  }


  checkFileValidation(): void {
    const params = this.parent as ReceiptParamsViewModel;
    this.allFilesUploaded = ExpenseFileUtils.areAllFilesUploaded(
      params.expenseData.files.filter((file) => file.isPrimaryFile.value !== true)
    );
  }


  currentImageModalSrc: SafeResourceUrl = null;
  currentImageModalBlob: Blob;
  currentImageModalName: string;
  currentItemInFullScreen: ExpenseFileCollectionItemViewModel;

  /**
   * Visualizza il prossimo file in modalità fullscreen
   *
   * @returns
   */
  showFullScreenNextImage(showOnlyFirst = false, hideFirst = false) {
    this.navigateFullScreenImage('next', showOnlyFirst, hideFirst);
  }

  /**
   * Visualizza il file precedente in modalità fullscreen
   *
   * @returns
   */
  showFullScreenPreviousImage(showOnlyFirst = false, hideFirst = false) {
    this.navigateFullScreenImage('previous', showOnlyFirst, hideFirst);
  }

  private navigateFullScreenImage(
    direction: 'next' | 'previous',
    showOnlyFirst = false,
    hideFirst = false
  ) {
    const params = this.parent as ReceiptParamsViewModel;
    ExpenseFileUtils.navigateFullScreenImage(
      params.expenseData.files.filter((file) => file.isPrimaryFile.value !== true),
      this.currentItemInFullScreen,
      direction,
      this,
      showOnlyFirst,
      hideFirst
    );
  }

}
